import React from 'react';

export const renderContentWithMentions = (
    text: string, 
    onMentionClick: (username: string) => void
) => {
    if (!text) return null;

    // regex to match @username (letters, numbers, underscores)
    const mentionRegex = /(@[a-zA-Z0-9_]+)/g;
    const parts = text.split(mentionRegex);

    return parts.map((part, i) => {
        if (part.match(mentionRegex)) {
            const username = part.substring(1); // remove the '@'
            return (
                <span 
                    key={i} 
                    onClick={(e) => {
                        e.stopPropagation();
                        onMentionClick(username);
                    }}
                    className="text-primary font-bold cursor-pointer hover:underline"
                >
                    {part}
                </span>
            );
        }
        return <span key={i}>{part}</span>;
    });
};
